import PropTypes from 'prop-types';
import React from 'react';
import { getLocationText, removeLocationExpansionParams } from '../common/locationUtils.js';
import { AjaxLink } from '../common/ajaxLink.js';
import { Svg } from '../common/Svg.js';

const getSchoolLink = (expandedLocationData) => {
    return <a href={expandedLocationData.sourceUrl}>{expandedLocationData.sourceName}</a>;
}
const buildMessage = (expandedLocationData) => {
    if (expandedLocationData == null) {
        return null;
    }

    if (!expandedLocationData.expansionSucceeded && !expandedLocationData.anyInitialResults) {
        if (source == null) {
            // Under current business rules (don't expand if a school-specific search found any results), this is
            // unreachable. That could change if we change our expansion thresholds.
            return null;
        } else {
            return <React.Fragment>{getSchoolLink(expandedLocationData)} doesn't have any {expandedLocationData.entityTypeName}s</React.Fragment>;
        }
    }

    let prefix;
    if (expandedLocationData.sourceName != null) {
        prefix = <React.Fragment>{getSchoolLink(expandedLocationData)} doesn't have any {expandedLocationData.entityTypeName}s, so</React.Fragment> ;
    } else {
        if (expandedLocationData.anyInitialResults) {
            prefix = `To find more ${expandedLocationData.entityTypeName}s,`;
        } else {
            prefix = `We didn't find any matching ${expandedLocationData.entityTypeName}s, so`;
        }
    }

    return <React.Fragment>{prefix} we expanded your search to {expandedLocationData.resultName}</React.Fragment>;
}

export const LocationExpansionMessage = ({callbacks, searchURL, expandedLocationData}) => {
    if (!expandedLocationData) {
        return null;
    }

    if (expandedLocationData) {
        const locationText = getLocationText(searchURL);
        let noExpansionLink;
        if (locationText) {
            noExpansionLink = (
                <AjaxLink handleLink={callbacks.changeURL} className="remove-expansion"
                          href={callbacks.makeSearchURL(removeLocationExpansionParams(searchURL))}>
                    <Svg icon="search" attributes={{ role: 'presentation' }}/> Only show results in {locationText}
                </AjaxLink>
            );
        }

        return (
            <div className="expanded-location">
                {buildMessage(expandedLocationData)}
                <a href={baseURL + 'donors/map.html'}><Svg icon="location" attributes={{ role: 'presentation' }}/>Find a school on a map</a><span className="divider">|</span>{noExpansionLink}
            </div>
        );
    }
}
LocationExpansionMessage.propTypes = {
    callbacks: PropTypes.object.isRequired,
    searchURL: PropTypes.object.isRequired,
    expandedLocationData: PropTypes.object,
}
